import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    ContainerStyled,
    MetricsRowStyled,
    MetricCardStyled,
    MetricValueStyled,
    MetricLabelStyled,
    PreviewContainerStyled,
    PreviewHeaderStyled,
    NotificationCardStyled,
    AvatarStyled,
    NotificationContentStyled,
    NotificationTitleRowStyled,
    NotificationTitleStyled,
    NotificationTimeStyled,
    NotificationBodyStyled,
    ActionsRowStyled,
    BackButtonStyled,
    ConfirmButtonStyled,
} from '../styled';
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";

class ModalConfirmationComponent extends Component {
    render() {
        const {
            recipientsCount,
            pushRecipientsCount,
            costPerSend,
            appInitial,
            notificationTitle,
            notificationBody,
            timeText,
            onBack,
            onConfirm,
            backLabel,
            confirmLabel,
        } = this.props;

        return (
            <ContainerStyled>
                <SpacerComponent height={20}/>
                {/* Bloco de Métricas */}
                <MetricsRowStyled>
                    <MetricCardStyled>
                        <MetricValueStyled>{recipientsCount}</MetricValueStyled>
                        <MetricLabelStyled>Destinatários</MetricLabelStyled>
                    </MetricCardStyled>

                    <MetricCardStyled>
                        <MetricValueStyled>{pushRecipientsCount}</MetricValueStyled>
                        <MetricLabelStyled>Receberão push</MetricLabelStyled>
                    </MetricCardStyled>

                    <MetricCardStyled>
                        <MetricValueStyled>{costPerSend}</MetricValueStyled>
                        <MetricLabelStyled>Custo por envio</MetricLabelStyled>
                    </MetricCardStyled>
                </MetricsRowStyled>

                {/* Card de Prévia */}
                <PreviewContainerStyled>
                    <PreviewHeaderStyled>
                        PRÉVIA DO PUSH NO CELULAR DO CLIENTE
                    </PreviewHeaderStyled>

                    <NotificationCardStyled>
                        <AvatarStyled>{appInitial}</AvatarStyled>

                        <NotificationContentStyled>
                            <NotificationTitleRowStyled>
                                <NotificationTitleStyled>{notificationTitle}</NotificationTitleStyled>
                                <NotificationTimeStyled>{timeText}</NotificationTimeStyled>
                            </NotificationTitleRowStyled>
                            <NotificationBodyStyled>{notificationBody}</NotificationBodyStyled>
                        </NotificationContentStyled>
                    </NotificationCardStyled>
                </PreviewContainerStyled>

                {/* Botões de Ação */}
                <ActionsRowStyled>
                    <BackButtonStyled type="button" onClick={onBack}>
                        {backLabel}
                    </BackButtonStyled>
                    <ConfirmButtonStyled type="button" onClick={onConfirm}>
                        {confirmLabel}
                    </ConfirmButtonStyled>
                </ActionsRowStyled>
            </ContainerStyled>
        );
    }
}

ModalConfirmationComponent.propTypes = {
    recipientsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pushRecipientsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    costPerSend: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    appInitial: PropTypes.string,
    notificationTitle: PropTypes.string.isRequired,
    notificationBody: PropTypes.string.isRequired,
    timeText: PropTypes.string,
    onBack: PropTypes.func,
    onConfirm: PropTypes.func,
    backLabel: PropTypes.string,
    confirmLabel: PropTypes.string,
};

ModalConfirmationComponent.defaultProps = {
    recipientsCount: 0,
    pushRecipientsCount: 0,
    costPerSend: 0,
    appInitial: 'M',
    timeText: 'agora',
    onBack: () => {
    },
    onConfirm: () => {
    },
    backLabel: 'VOLTAR',
    confirmLabel: 'CONFIRMAR ENVIO',
};

export default ModalConfirmationComponent;